export function arraysHaveSameValues<T>(arr1: T[], arr2: T[]): boolean {
  return arr1.length === arr2.length && new Set([...arr1, ...arr2]).size === arr1.length;
}
